import { PaginatedResponse } from '@/utils/types';
import { AxiosResponse } from 'axios';

export type CompactProcessObject = {
	id: number;
	name: string;
};

export type ProcessObjectFile = {
	id: number;
	userId: number;
	name: string;
	path: string;
	processObjectId: number;
	createdAt: string;
	title: string;
	description: string;
};

export type Ttms = {
	id: number;
	city: string;
	state: string;
	ttmsZone: string;
};

export type ProcessObjectListLoaderResponse = {
	processObjectList: AxiosResponse<PaginatedResponse<ProcessObject>>;
	ttmsList: AxiosResponse<Ttms[]>;
};

export type CreateProcessObjectRequest = {
	name: string;
	voltageLines: number[];
	primaryTtms: number;
	secondaryTtms: number;
};

export type ProcessObject = {
	id: number;
	name: string;
	msIds: number[];
	ttmsIdPrimary: number;
	ttmsIdSecondary: number;
	algorithm: number;
	cx: number;
	cy: number;
	timeAdjustment: number;
	kvClass: number;
	latestKofFile: string;
	trmsLimit: number;
	relationsDetails: {
		mgId: number;
		mgName: string;
		ipoId: number;
		primaryCalibrationFactor: number;
	}[];
};

export enum ProcessObjectSortColumns {
	id = 'ID',
	name = 'NAME',
	ttmsIdPrimary = 'PRIMARY_TTMS',
	ttmsIdSecondary = 'SECONDARY_TTMS',
	trmsLimit = 'TRMS_LIMIT',
	algorithm = 'ALGO',
	kvClass = 'VOLTAGE',
	cx = 'CX',
	cy = 'CY',
	timeAdjustment = 'TIME_ADJUST'
}
